export default "__VITE_ASSET__DhDPqGCi__"